import getAppHeaderNavLinks from "../components/appHeader/lib/getAppHeaderNavLinks";
import {
  COMMUNICATION_LOGS_ACCESS,
  INBOX_ACCESS,
  PIPELINES_ACCESS,
  REPORTS_ACCESS,
  TODOS_ACCESS
} from "./constants/permissions";
import {defaultFolders} from "../screens/inbox/store/inboxFoldersSelector";

const permissionMatchMap = {
  [INBOX_ACCESS]: /^\/\d+\/inbox/g,
  [PIPELINES_ACCESS]: /^\/\d+\/pipelines/g,
  [TODOS_ACCESS]: /^\/\d+\/todos/g,
  [REPORTS_ACCESS]: /^\/\d+\/reports/g,
  [COMMUNICATION_LOGS_ACCESS]: /^\/\d+\/activity\/communication-logs/g,
};

/*
* Iterate through permissions above, order of keys determined by importance
* If permission key is valid, and a header link matches the regex exp, redirect to that link url
* */
const getPermissionBasedRoute = (links, serviceProvider) => {
  let url = null;
  const permissionMatchKeys = Object.keys(permissionMatchMap);
  for(let i = 0; i < permissionMatchKeys.length; i++) {
    const permissionKey = permissionMatchKeys[i];
    const validPermission = ((serviceProvider || {}).permissions || []).includes(permissionKey);
    if(validPermission) {
      let linkMatched = links.find(n => n.link.match(permissionMatchMap[permissionKey]))
      if(linkMatched) {
        url = linkMatched.link
        break;
      }
    }
  }
  return url;
}

const getDefaultUserRoute = (serviceProviderId, userServiceProviders = [], serviceProvider = {}, tresioUser = false) => {
  let defaultUrl = userServiceProviders.length ? `/${serviceProviderId}/inbox/inbox` : ``;
  const defaultPipelineId = ((serviceProvider.pipelines || [])[0] || {}).id
  const additionalFields = serviceProvider.additionalFields || serviceProvider.additional_fields || {}
  const baseFolders = ((additionalFields.inbox || {}).folders || []).length ? additionalFields.inbox.folders : defaultFolders;
  const folders = baseFolders.filter(n => n.visibility.includes('nav'));
  const links = getAppHeaderNavLinks({
    folders,
    serviceProviderId,
    defaultPipelineId,
    params: {serviceProviderId},
    location: window.location,
  });
  const allowedRoute = getPermissionBasedRoute(links, serviceProvider)
  return tresioUser ? links[0].link : (allowedRoute ? allowedRoute : defaultUrl);
};

export default getDefaultUserRoute;
